module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Media/Airplay-d02dfb41d808ae8f14ce6b555924e5c52567f8c8a6f8f1b009000f02375810ac.svg";